import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.user-templates': {
         formsTemplates: {
            addTemplate: 'Dodaj szablon',
            areYourSureRemovingTemplate:
               'Czy na pewno chcesz usunąć szablon o nazwie <strong>{{templateName}}</strong>?',
            cancel: 'Anuluj',
            insert: 'Wstaw',
            inserted: 'Wstawiono',
            leavingForm: {
               title: 'Wychodzisz z formularza',
            },
            name: 'Nazwa',
            noInformation: 'Brak informacji',
            noSearchResults: 'Brak pasujących szablonów',
            noTemplates: 'Brak szablonów',
            remove: 'Usuń',
            save: 'Zapisz',
            saveTemplate: 'Zapisz szablon',
            templateName: 'Nazwa szablonu',
            templateNameOccupied: 'Szablon o takiej nazwie już istnieje.',
            templateSavedSuccessfully: 'Szablon został zapisany.',
            templatesFetchError: 'Błąd pobrania listy szablonów. Spróbuj ponownie.',
            use: 'Użyj',
            useTemplate: 'Użyj szablonu',
            usingTemplate: 'Używasz szablonu',
         },
      },
   },
};

const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.desktop.shared.user-templates');

export const formsTemplatesTranslationKeys = translationKeys.formsTemplates;
